export const GoogleMapApiConfig = 'AIzaSyBOjKt_20edjF7BFTuu0i_Qv4cH0VJLbZs';